import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Shield, Loader2, Lock } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Connexion impossible");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-900 p-4 font-admin">
      <div className="w-full max-w-md">
        <div className="mb-6 flex items-center gap-3">
          <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-sky-400 text-slate-900">
            <Shield className="h-6 w-6" />
          </span>
          <div>
            <h1 className="font-display text-xl font-bold text-white">Console RGPD</h1>
            <p className="text-sm text-slate-400">Backoffice de paramétrage & publication</p>
          </div>
        </div>
        <form
          onSubmit={submit}
          className="rounded-xl border border-slate-700 bg-slate-800 p-6 shadow-xl"
          data-testid="admin-login-form"
        >
          <label htmlFor="login-email" className="mb-1.5 block text-xs font-semibold uppercase tracking-wider text-slate-400">
            E-mail
          </label>
          <input
            id="login-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mb-4 w-full rounded-md border border-slate-600 bg-slate-900 px-3 py-2.5 text-sm text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-400"
            required
            data-testid="admin-login-email"
          />
          <label htmlFor="login-password" className="mb-1.5 block text-xs font-semibold uppercase tracking-wider text-slate-400">
            Mot de passe
          </label>
          <input
            id="login-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="mb-4 w-full rounded-md border border-slate-600 bg-slate-900 px-3 py-2.5 text-sm text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-400"
            required
            data-testid="admin-login-password"
          />
          {error && (
            <p role="alert" className="mb-4 rounded-md bg-red-500/10 px-3 py-2 text-sm text-red-300" data-testid="admin-login-error">
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={loading}
            className="flex w-full items-center justify-center gap-2 rounded-md bg-sky-400 px-4 py-2.5 text-sm font-semibold text-slate-900 transition-colors hover:bg-sky-300 disabled:opacity-60"
            data-testid="admin-login-submit"
          >
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Lock className="h-4 w-4" />}
            Se connecter
          </button>
        </form>
        <p className="mt-4 text-center text-xs text-slate-500">
          Accès réservé aux administrateurs autorisés.
        </p>
      </div>
    </div>
  );
}
